export enum ModalTypes {
  SET_MODAL_IS_OPENED = '@modal/SET_MODAL_IS_OPENED'
}

export interface ModalState {
  readonly open: boolean;
  readonly name: string | null;
}

export interface SetModalIsOpened {
  type: typeof ModalTypes.SET_MODAL_IS_OPENED;
  payload: { open: boolean; name: string | null };
}

export type ModalActionTypes = SetModalIsOpened;
